export const bottomNavConfig = {
  screens: [],
};

export const homeButtonsConfig = {
  leftButtons: [
    {
      id: 'ranking',
      iconKey: 'ranking',
      label: 'Ranking',
      action: 'goToRanking',
    },
    {
      id: 'progress',
      iconKey: 'progress',
      label: 'Map',
      action: 'goToProgress',
    },
  ],
  rightButtons: [
    {
      id: 'settings',
      iconKey: 'settings',
      label: 'Settings',
      action: 'goToSettings',
    },
  ],
};
